module.exports = __webpack_public_path__ + "static/media/02_BOJO_MEIA_TACA_LISO_01.d398ac00.jpg";